import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WatchProgress } from '../../interfaces/watch-progress';
import { IPartnerService } from '../../interfaces/partner-services';
import { ConfigService } from '@outlaw/core';
import { buildPartnerUrl } from '../../generators/partner-config-url.generator';

@Injectable({
  providedIn: 'root',
})
export class PartnerService implements IPartnerService {
  protected http = inject(HttpClient);
  protected videoUrl = buildPartnerUrl(inject(ConfigService).apiConfig.videoUrl);

  getServiceUrl(): string {
    return '';
  }

  addWatchProgressToVideo(id: number, params: WatchProgress): Observable<void> {
    params.from_platform = 'web';
    return this.http.put<void>(`${this.getServiceUrl()}${this.videoUrl}/${id}/watching/`, params);
  }
}
